.workflow-view-detail-filter-buttons {
  padding: 0 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

@media (max-width: 767px) {
  .workflow-view-comments-card__filters {
    flex-direction: column;
  }

  .workflow-view-detail-filter-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }

  .submital-detail-filter-name {
    align-self: flex-start;
  }
}

.workflow-view-comments-card__filters.mobile-layout {
  flex-direction: column;
}

.workflow-view-comments-card__filters.mobile-layout .workflow-view-detail-filter-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.workflow-view-comments-card__filters.mobile-layout .submital-detail-filter-name {
  align-self: flex-start;
}

.workflow-view-detail-feed-container {
  border-top: 1px solid var(--background-color-step-150);
}

.workflow-view-detail-info-container {
  border: 1px solid var(--background-color-step-150);
  border-top-left-radius: 1rem;
  background-color: var(--background-color-step-50);
  padding: 0.5rem 0.25rem;
}

.workflow-view__ion-content {
  min-width: 0;
  overflow: hidden;
}

.workflow-view__ion-content::part(scroll) {
  min-width: 0;
  overflow-x: hidden;
}

.workflow-view__grid {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.workflow-view__content-container {
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.workflow-view__document-col {
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.workflow-view__left-column {
  flex: 1 1 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.workflow-view__timeline-container {
  flex: 0 0 auto;
}

.workflow-view__comments-container {
  min-height: 0;
}
